module.exports = __webpack_public_path__ + "static/media/close.e342dbb2.svg";